import React from 'react';

interface VisibilityWrapperProps {
  visible: boolean;
  children?: React.ReactNode;
  className?: string;
}

const VisibilityWrapper = ({
  visible,
  children,
  className,
}: VisibilityWrapperProps) => {
  let visibilityStyle = null;
  if (!visible) visibilityStyle = { display: 'none' };
  return (
    <div className={className} style={visibilityStyle}>
      {children}
    </div>
  );
};

export default VisibilityWrapper;
